import React from 'react';
import PropTypes from 'prop-types';
import { pxToRem } from 'utils';

const UiLabel = ({
  children,
  color,
  size,
  pointer,
  className,
  onClick,
  ...otherProps
}) => {
  return (
    <span
      style={{
        color: color,
        fontSize: pxToRem(size),
        cursor: pointer ? 'pointer' : 'default',
        ...otherProps,
      }}
      onClick={onClick}
      className={className}
    >
      {children}
    </span>
  );
};

UiLabel.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  pointer: PropTypes.bool,
  onClick: PropTypes.func,
};

export default UiLabel;
